import * as React from 'react';

import { mergeStyles } from '@cian/utils/lib/shared/style';

import { getVacanciesUrl } from '../vacancies/vacancies';
import { ISearchFilter } from '../vacancies_filter/vacancies_filter';

import * as styles from './pagination.css';
import { LinkButton } from '@cian/ui-kit';

interface IPaginationProps {
  filter: ISearchFilter;
  onPageChanged(page: number): void;
  pageCount: number;
}

const createHref = (filter: ISearchFilter, p: number) => {
  const urlParams = { ...filter, p };

  return getVacanciesUrl(urlParams);
};

const getPagesList = (pageCount: number, activePage: number): number[] => {
  const result: number[] = [];
  const minPage: number = activePage - 7 > 0 ? activePage - 7 : 1;
  let maxPage: number;

  if (activePage + 7 > pageCount) {
    maxPage = pageCount;
  } else if (activePage + 7 > 30) {
    maxPage = 30;
  } else {
    maxPage = activePage + 7;
  }

  for (let i = minPage; i <= maxPage; i++) {
    result.push(i);
  }

  return result;
};

const Pagination = (props: IPaginationProps) => {
  const activePage = props.filter.p || 1;

  return (
    <ul className={styles['container']}>
      {activePage - 8 >= 1 && (
        <li className={styles['number']}>
          <LinkButton
            size="XS"
            theme="fill_white_primary"
            href={createHref(props.filter, 1)}
            onClick={event => {
              event.preventDefault();
              props.onPageChanged(1);
            }}
          >
            1
          </LinkButton>
        </li>
      )}
      {activePage - 8 > 1 && (
        <li className={styles['number']}>
          <LinkButton
            theme="fill_white_primary"
            href={createHref(props.filter, activePage - 8)}
            onClick={event => {
              event.preventDefault();
              props.onPageChanged(activePage - 8);
            }}
          >
            …
          </LinkButton>
        </li>
      )}
      {getPagesList(props.pageCount, activePage).map(p => (
        <li key={p} {...mergeStyles(styles['number'], activePage === p && styles['active'])}>
          {activePage === p ? (
            p
          ) : (
            <LinkButton
              theme="fill_white_primary"
              href={createHref(props.filter, p)}
              onClick={event => {
                event.preventDefault();
                props.onPageChanged(p);
              }}
            >
              {p}
            </LinkButton>
          )}
        </li>
      ))}
      {activePage + 8 <= props.pageCount && activePage + 8 <= 30 && (
        <li className={styles['number']}>
          <LinkButton
            theme="fill_white_primary"
            href={createHref(props.filter, activePage + 8)}
            onClick={event => {
              event.preventDefault();
              props.onPageChanged(activePage + 8);
            }}
          >
            …
          </LinkButton>
        </li>
      )}
    </ul>
  );
};

export { Pagination };
